import {ElementRef, OnInit, Directive, HostListener, inject, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Directive({
  selector: '[bz-image]',
})
export class BzImageDirective implements OnInit {

  constructor(
    private elementRef: ElementRef<HTMLImageElement>,
    @Inject(PLATFORM_ID) private platformId: {}
  ) {}

  ngOnInit(): void {
    this.initImage();
    this.setPriority();
  }

  @HostListener('error')
  loadFallbackError(): void {
  //   TODO we can improving our realisation handle error image
  }

  @HostListener('load')
  loadSuccess(): void {
    //   TODO we can improving our realisation loading image
  }

  private initImage(): void {
    //   TODO we can improving initial image
  }

  private setPriority(): void {
    if (isPlatformBrowser(this.platformId)) {
      const isPriorityHeight: boolean = this.elementRef.nativeElement?.getBoundingClientRect()?.top < window?.innerHeight;
      const isPriorityWidth: boolean = this.elementRef.nativeElement?.getBoundingClientRect()?.left < window?.innerWidth;
      if (isPriorityHeight && isPriorityWidth) {
        this.elementRef.nativeElement.setAttribute('fetchPriority', 'high');
      } else {
        this.elementRef.nativeElement.setAttribute('loading', 'lazy');
      }
    }
  }

}
